export default {
  'apps.title': 'Apps',
  'apps.subtitle': 'Crea y gestiona aplicaciones generadas por IA',
  'apps.empty': 'No hay aplicaciones',
  'apps.empty.description': 'Crea tu primera aplicación con el asistente de IA',

  // Buttons
  'apps.button.create': 'Crear App',
  'apps.button.open': 'Abrir',
  'apps.button.builder': 'Builder',
  'apps.button.preview': 'Vista Previa',
  'apps.button.edit': 'Editar',
  'apps.button.delete': 'Eliminar',
  'apps.button.duplicate': 'Duplicar',
  'apps.button.copy': 'Copiar',

  // Copy flow (preview + execute)
  'apps.copy.title': 'Copiar App',
  'apps.copy.source.section': 'App de origen',
  'apps.copy.target.section': 'Destino',
  'apps.copy.targetCompany': 'Compañía destino',
  'apps.copy.targetCompany.placeholder': 'Selecciona una compañía',
  'apps.copy.targetCompany.required': 'La compañía destino es requerida',
  'apps.copy.targetEnvironment': 'Ambiente destino',
  'apps.copy.targetEnvironment.placeholder': 'Selecciona un ambiente',
  'apps.copy.targetEnvironment.required': 'El ambiente destino es requerido',
  'apps.copy.targetEnvironment.pickCompanyFirst': 'Selecciona primero una compañía',

  'apps.copy.preview.button': 'Calcular vista previa',
  'apps.copy.preview.computing': 'Calculando vista previa...',
  'apps.copy.preview.ready': 'Vista previa lista — revisa abajo antes de copiar',
  'apps.copy.preview.retry': 'Reintentar',
  'apps.copy.preview.section': 'Vista previa de migración',
  'apps.copy.preview.sourceVersion': 'Versión de origen',
  'apps.copy.preview.permissions': 'Permisos a copiar',
  'apps.copy.preview.accessControl': 'Control de acceso a copiar',
  'apps.copy.preview.config': 'Configuración a copiar',
  'apps.copy.preview.empty': 'Sin elementos',
  'apps.copy.preview.warnings': 'Advertencias',
  'apps.copy.preview.noWarnings': 'Sin advertencias',
  'apps.copy.preview.error': 'No se pudo obtener la vista previa',
  'apps.copy.preview.hint': 'Selecciona la compañía y el ambiente destino para ver qué se copiará.',

  'apps.copy.overrides.section': 'Personalización de la copia',
  'apps.copy.newName': 'Nombre de la copia',
  'apps.copy.newName.placeholder': 'Nombre para la nueva app',
  'apps.copy.newName.required': 'El nombre de la nueva app es requerido',
  'apps.copy.newDescription': 'Descripción',
  'apps.copy.newDescription.placeholder': 'Describe brevemente la nueva app',

  'apps.copy.select.searchPlaceholder': 'Buscar...',
  'apps.copy.config.hint':
    'Se copia tal cual desde el origen. Edita el JSON si necesitas remapear identificadores o valores específicos del destino.',
  'apps.copy.config.invalid': 'JSON inválido',
  'apps.copy.config.beautify': 'Formatear',
  'apps.copy.version.label': 'Versión origen',
  'apps.copy.version.auto': 'Auto',
  'apps.copy.version.auto.hint': 'Última versión publicada',
  'apps.copy.version.current': 'actual',
  'apps.copy.version.published': 'publicada',
  'apps.copy.source.label': 'App de origen',
  'apps.copy.confirm': 'Copiar app',
  'apps.copy.success': 'App copiada exitosamente',
  'apps.copy.error': 'Error al copiar la app',
  'apps.copy.openBuilder': 'Abrir builder',
  'apps.copy.success.warningsHint': 'Notas para revisar en el destino',
  'apps.copy.success.moreWarnings': '+{count} notas adicionales',
  'apps.copy.success.referencePermissions': 'Permisos del origen (referencia)',
  'apps.copy.success.referenceAccessControl': 'Control de acceso del origen (referencia)',
  'apps.copy.success.referenceMore': '+{count} más',

  'apps.copy.warning.missing-reference-in-target':
    'Referencia no disponible en el destino — revisa después de copiar',
  'apps.copy.warning.cross-company-permission-reference':
    'Permiso entre compañías — puede que no aplique en el destino',
  'apps.copy.warning.config-guid-reference-review':
    'Identificador hardcodeado en la configuración — actualízalo en el destino',
  'apps.copy.warning.unknown': 'Nota sobre la copia',

  // Form
  'apps.form.name': 'Nombre',
  'apps.form.name.placeholder': 'Nombre de la aplicación',
  'apps.form.name.required': 'El nombre es requerido',
  'apps.form.description': 'Descripción',
  'apps.form.description.placeholder': 'Describe brevemente tu aplicación',
  'apps.form.icon': 'Icono',
  'apps.form.coverImage': 'Imagen de Portada',
  'apps.form.isActive': 'Activa',

  // Wizard steps
  'apps.wizard.steps.initial': 'Inicial',
  'apps.wizard.steps.basicInformation': 'Información Básica',
  'apps.wizard.steps.personalization': 'Personalización',
  'apps.wizard.steps.manifest': 'Manifest',
  'apps.wizard.steps.login': 'Login',
  'apps.wizard.steps.appPermissions': 'Permisos',
  'apps.wizard.steps.appAccessControl': 'Control de Acceso',

  // App Permissions (step 5)
  'apps.form.permissions.processes': 'Procesos',
  'apps.form.permissions.process': 'Proceso',
  'apps.form.permissions.lists': 'Listas',
  'apps.form.permissions.list': 'Lista',
  'apps.form.permissions.reports': 'Reportes',
  'apps.form.permissions.report': 'Reporte',
  'apps.form.permissions.entities': 'Entidades',
  'apps.form.permissions.entity': 'Entidad',
  'apps.form.permissions.aiAgents': 'Agentes IA',
  'apps.form.permissions.aiAgent': 'Agente IA',
  'apps.form.permissions.connections': 'Conexiones',
  'apps.form.permissions.connection': 'Conexión',

  // App Access Control (step 6)
  'apps.form.accessControl.users': 'Usuarios',
  'apps.form.accessControl.user': 'Usuario',
  'apps.form.accessControl.userGroups': 'Grupos de usuario',
  'apps.form.accessControl.userGroup': 'Grupo de usuario',
  'apps.form.accessControl.positions': 'Posiciones',
  'apps.form.accessControl.position': 'Posición',
  'apps.form.accessControl.areas': 'Áreas',
  'apps.form.accessControl.area': 'Área',

  // Manifest
  'apps.form.manifestThemeColor': 'Color tema',
  'apps.form.manifestBackgroundColor': 'Color de fondo',
  'apps.form.manifestIcon192x192': 'Icono 192x192',
  'apps.form.manifestIcon512x512': 'Icono 512x512',

  // Login
  'apps.form.loginLogo': 'Logo',
  'apps.form.loginSplash': 'Splash',
  'apps.form.loginMainColor': 'Color principal',
  'apps.form.loginDisableUserAndPass': 'Deshabilitar usuario y contraseña',
  'apps.form.loginDisableOffice365': 'Deshabilitar Office 365',
  'apps.form.loginDisableGoogle': 'Deshabilitar Google',
  'apps.form.loginDisableChangeToAutomy': 'Deshabilitar cambio a Automy',

  'apps.form.owner': 'Propietario',

  // Auth mode (AppAuthMode)
  'apps.form.authMode': 'Modo de autenticación',
  'apps.form.authMode.automy': 'Automy',
  'apps.form.authMode.selfmanaged': 'Autogestionado',

  // Builder
  'apps.builder.title': 'App Builder',
  'apps.builder.error.notFound': 'La aplicación no existe o no se encontró',
  'apps.builder.chat.title': 'Asistente IA',
  'apps.builder.chat.placeholder': 'Describe qué quieres que tenga tu aplicación...',
  'apps.builder.chat.welcome':
    'Soy tu asistente para crear aplicaciones. Describe qué tipo de app necesitas y la construiré para ti.',
  'apps.builder.preview': 'Vista Previa',
  'apps.builder.code': 'Código',
  'apps.builder.noPreview': 'Tu aplicación comienza aquí',
  'apps.builder.noPreview.description':
    'Describe lo que necesitas en el chat y la IA construirá tu aplicación paso a paso',
  'apps.builder.noPreview.hint': 'Escribe en el chat para comenzar',
  'apps.builder.generating': 'Generando aplicación...',
  'apps.builder.refresh': 'Refrescar',
  'apps.builder.chat.subtitle': 'Crea y modifica tu aplicación',
  'apps.builder.chat.you': 'Tú',
  'apps.builder.chat.assistant': 'Asistente IA',
  'apps.builder.chat.thinking': 'Pensando...',
  'apps.builder.chat.error': 'No se pudo inicializar el chat',
  'apps.builder.chat.disclaimer':
    'La IA puede generar contenido inexacto. Verifica los resultados.',
  'apps.builder.chat.noConnection': 'No hay conexión. Intenta de nuevo.',
  'apps.builder.chat.open': 'Abrir chat',
  'apps.builder.chat.close': 'Cerrar chat',
  'apps.builder.open': 'Abrir',
  'apps.builder.publish': 'Publicar',
  'apps.builder.panel.saving': 'Guardando...',
  'apps.builder.unsaved.indicator': 'Cambios sin guardar',
  'apps.builder.unsaved.confirm':
    'Tienes cambios sin guardar. ¿Seguro que quieres salir y descartarlos?',
  'apps.builder.create.error': 'No se pudo crear la app',
  'apps.builder.newApp.title': 'Nueva App',
  'apps.builder.newApp.continue': 'Continuar',
  'apps.builder.sidebar.overview': 'Vista general',
  'apps.builder.section.basicInformation': 'Información básica',
  'apps.builder.section.personalization': 'Personalización',
  'apps.builder.section.manifest': 'Manifest',
  'apps.builder.section.login': 'Login',
  'apps.builder.section.permissions': 'Permisos',
  'apps.builder.section.accessControl': 'Control de acceso',
  'apps.builder.publish.success': 'Aplicación publicada exitosamente',
  'apps.builder.publish.error': 'Error al publicar la aplicación',
  'apps.builder.setCurrent': 'Establecer actual',
  'apps.builder.setCurrent.success': 'Versión establecida como actual exitosamente',
  'apps.builder.setCurrent.error': 'Error al establecer la versión como actual',
  'apps.builder.version.error': 'Error al cambiar de versión',
  'apps.builder.version.publishedBy': 'Publicado por',
  'apps.builder.version.publishedDate': 'Fecha',
  'apps.builder.code.explorer': 'EXPLORADOR',
  'apps.builder.code.selectFile': 'Selecciona un archivo para ver su contenido',

  // View
  'apps.view.fullscreen': 'Pantalla completa',
  'apps.view.exitFullscreen': 'Salir de pantalla completa',

  // Card
  'apps.card.active': 'Activa',
  'apps.card.inactive': 'Inactiva',
  'apps.card.createdBy': 'Creado por',
  'apps.card.lastModified': 'Última modificación',

  // Status
  'apps.status.active': 'Activa',
  'apps.status.inactive': 'Inactiva',

  // Process Form Drawer
  'apps.processForm.load.error': 'Error al cargar el formulario',
  'apps.processForm.submit.success': 'Formulario enviado correctamente',
  'apps.processForm.submit.error': 'Error al enviar el formulario',

  // Report Embed Drawer
  'apps.report.title': 'Reporte',
  'apps.report.load.error': 'No se pudo cargar el reporte',

  // App View Errors
  'apps.view.providerNotAvailable': 'Proveedor "{providerName}" no disponible',
  'apps.view.providerError': 'Error del proveedor',
  'apps.view.loadError': 'Error al cargar la app',

  // Code Viewer
  'apps.builder.code.explorer': 'EXPLORADOR',
  'apps.builder.code.selectFile': 'Selecciona un archivo para ver su contenido',

  // App View errors
  'apps.view.error.loading': 'Error al cargar la aplicación',
  'apps.view.error.providerNotAvailable': 'Proveedor "{providerName}" no disponible',
  'apps.view.error.providerError': 'Error en el proveedor',

  // Auth
  'apps.view.error.auth': 'No tienes acceso a esta aplicación o tu sesión expiró',

  // Not Published
  'apps.notPublished.title': 'App no publicada',
  'apps.notPublished.description':
    'Esta aplicación aún no tiene una versión publicada. Abre el builder para configurarla y publicarla.',
  'apps.notPublished.back': 'Volver a Apps',

  // PWA Install
  'apps.pwa.installPrompt': 'Instalar "{appName}" en tu dispositivo',
  'apps.pwa.install': 'Instalar',

  // Common
  'apps.common.close': 'Cerrar',

  // Offline
  'apps.offline.banner.offline':
    'Estás sin conexión. Los cambios se guardarán localmente y se sincronizarán automáticamente.',
  'apps.offline.banner.syncing': 'Sincronizando cambios pendientes...',
  'apps.offline.banner.pending': 'Conexión restaurada. Cambios pendientes: {count}.',
  'apps.offline.banner.failed': 'Algunos cambios no se pudieron sincronizar: {count}.',
  'apps.offline.badge.offline': 'Sin conexión',
  'apps.offline.badge.syncing': 'Sincronizando',
  'apps.offline.badge.pending': 'Pendientes: {count}',
  'apps.offline.badge.failed': 'Errores: {count}',
  'apps.offline.error.noCache': 'No hay conexión y no existe caché offline disponible.',
};
